import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./baseStyles.css";
import "./ItemManagerPage.css";

const apiUrl = process.env.REACT_APP_API_URL;

const blankForm = {
  campaignItemsId: "",
  campaignItemsType: "ListItem",
  campaignItemsAuthor: "",
  campaignItemsName: "",
  campaignItemsText: "",
  campaignItemsURL1: "",

  foodDate: "",
  foodLocation: "",
  foodRating: "",

  wineProducer: "",
  wineName: "",
  wineVintage: "",
  wineMyRating: "",
  wineOtherRatings: [],
  wineLocation: "",
  wineNotes: "",

  myOrganizerOriginalInput: "",
  myOrganizerDecision: "",
  myOrganizerNeedsAttentionReason: "",
  myOrganizerSuggestedList: "",
  moveToCampaignName: "",
};

const sortItems = (list) =>
  [...list].sort((a, b) => {
    const aOrder =
      a.campaignItemsSortOrder != null
        ? Number(a.campaignItemsSortOrder)
        : Number(a.campaignItemsId || 0);

    const bOrder =
      b.campaignItemsSortOrder != null
        ? Number(b.campaignItemsSortOrder)
        : Number(b.campaignItemsId || 0);

    if (aOrder !== bOrder) return aOrder - bOrder;
    return Number(a.campaignItemsId || 0) - Number(b.campaignItemsId || 0);
  });

const sortWineItems = (list) =>
  [...list].sort((a, b) => {
    const aRating =
      a.wineMyRating != null && a.wineMyRating !== ""
        ? Number(a.wineMyRating)
        : -1;

    const bRating =
      b.wineMyRating != null && b.wineMyRating !== ""
        ? Number(b.wineMyRating)
        : -1;

    if (aRating !== bRating) return bRating - aRating;

    return Number(a.campaignItemsId || 0) - Number(b.campaignItemsId || 0);
  });

const moveArrayItem = (array, fromIndex, toIndex) => {
  const copy = [...array];

  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= copy.length ||
    toIndex >= copy.length ||
    fromIndex === toIndex
  ) {
    return copy;
  }

  const [moved] = copy.splice(fromIndex, 1);
  copy.splice(toIndex, 0, moved);
  return copy;
};

const UserListItems = ({
  items = [],
  selectedCampaign,
  processorType = "simple_list",
  listRecord = null,
  userId,
  onRefresh,
  onDelete,
  onReorder,
  organizerMoveLists = [],
  onMoveItem,
}) => {
  const [displayItems, setDisplayItems] = useState(() =>
    processorType === "wine" ? sortWineItems(items) : sortItems(items)
  );
  const [form, setForm] = useState(blankForm);
  const [showEditModal, setShowEditModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const draggingRef = useRef(false);

  const isNeedsAttention = processorType === "needs_attention";
  const isWine = processorType === "wine";
  const isFood = processorType === "food";

  useEffect(() => {
    setDisplayItems(isWine ? sortWineItems(items) : sortItems(items));
  }, [items, isWine]);

  useEffect(() => {
    setDisplayItems(isWine ? sortWineItems(items) : sortItems(items));
    setDraggingId(null);
    setDragOverId(null);
  }, [selectedCampaign, isWine]);

  const openAdd = () => {
    setError("");
    setForm({
      ...blankForm,
      campaignItemsType: isWine
        ? "WineRating"
        : isFood
        ? "Food"
        : "ListItem",
    });
    setShowEditModal(true);
  };

  const openEdit = (item) => {
    setError("");

    const otherRatings = Array.isArray(item.wineOtherRatings)
      ? item.wineOtherRatings.map((entry) => ({
          name: entry?.name || "",
          rating:
            entry?.rating !== undefined && entry?.rating !== null
              ? String(entry.rating)
              : "",
        }))
      : [];

    setForm({
      ...blankForm,

      campaignItemsId: item.campaignItemsId ?? "",
      campaignItemsType:
        item.campaignItemsType ||
        (isWine ? "WineRating" : isFood ? "Food" : "ListItem"),

      campaignItemsAuthor: item.campaignItemsAuthor || "",
      campaignItemsName: item.campaignItemsName || "",
      campaignItemsText: item.campaignItemsText || "",
      campaignItemsURL1: item.campaignItemsURL1 || "",

      foodDate: item.foodDate || "",
      foodLocation: item.foodLocation || "",
      foodRating:
        item.foodRating !== undefined && item.foodRating !== null
          ? String(item.foodRating)
          : "",

      wineProducer: item.wineProducer || "",
      wineName: item.wineName || "",
      wineVintage: item.wineVintage || "",
      wineMyRating:
        item.wineMyRating !== undefined && item.wineMyRating !== null
          ? String(item.wineMyRating)
          : "",
      wineOtherRatings: otherRatings,
      wineLocation: item.wineLocation || "",
      wineNotes: item.wineNotes || "",

      myOrganizerOriginalInput: item.myOrganizerOriginalInput || "",
      myOrganizerDecision: item.myOrganizerDecision || "",
      myOrganizerNeedsAttentionReason:
        item.myOrganizerNeedsAttentionReason || "",
      myOrganizerSuggestedList: item.myOrganizerSuggestedList || "",
      moveToCampaignName: selectedCampaign || "",
    });

    setShowEditModal(true);
  };

  const closeEdit = () => {
    if (saving) return;
    setShowEditModal(false);
    setForm(blankForm);
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleWineOtherRatingChange = (index, field, value) => {
    setForm((prev) => {
      const nextRatings = [...(prev.wineOtherRatings || [])];

      nextRatings[index] = {
        ...(nextRatings[index] || {}),
        [field]: value,
      };

      return {
        ...prev,
        wineOtherRatings: nextRatings,
      };
    });
  };

  const addWineOtherRating = () => {
    setForm((prev) => ({
      ...prev,
      wineOtherRatings: [
        ...(prev.wineOtherRatings || []),
        { name: "", rating: "" },
      ],
    }));
  };

  const removeWineOtherRating = (index) => {
    setForm((prev) => ({
      ...prev,
      wineOtherRatings: (prev.wineOtherRatings || []).filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleSave = async () => {
    if (!selectedCampaign || !userId) {
      setError("Missing list or user information.");
      return;
    }

    const token = localStorage.getItem("idToken");

    if (!token) {
      setError("User is not authenticated.");
      return;
    }

    const isUpdate =
      form.campaignItemsId !== "" &&
      form.campaignItemsId !== null &&
      form.campaignItemsId !== undefined;

    const payload = {
      operation: isUpdate ? "update_campaign_item" : "add_campaign_item",
      userid: userId,
      campaignName: selectedCampaign,
      ...(isUpdate && {
        campaignItemsId: parseInt(form.campaignItemsId, 10),
      }),
      campaignItemsType:
        form.campaignItemsType ||
        (isWine ? "WineRating" : isFood ? "Food" : "ListItem"),
      campaignItemsAuthor: form.campaignItemsAuthor || "",
      campaignItemsURL1: form.campaignItemsURL1 || "",
    };

    if (isWine) {
      const wineName = (form.wineName || form.campaignItemsName || "").trim();
      const wineVintage = (form.wineVintage || "").trim();

      const otherRatings = (form.wineOtherRatings || [])
        .map((entry) => ({
          name: (entry?.name || "").trim(),
          rating:
            entry?.rating === "" ||
            entry?.rating === null ||
            entry?.rating === undefined
              ? null
              : Number(entry.rating),
        }))
        .filter(
          (entry) =>
            entry.name &&
            entry.rating !== null &&
            Number.isFinite(entry.rating) &&
            entry.rating >= 0 &&
            entry.rating <= 100
        );

      payload.campaignItemsName = [wineName, wineVintage]
        .filter(Boolean)
        .join(" ");

      // Preserve existing campaignItemsText on edits.
      // The permanent original capture is never sent back or changed.
      payload.campaignItemsText = isUpdate
        ? form.campaignItemsText || ""
        : form.wineNotes || "";

      payload.wineProducer = form.wineProducer || "";
      payload.wineName = wineName;
      payload.wineVintage = wineVintage;
      payload.wineLocation = form.wineLocation || "";
      payload.wineNotes = form.wineNotes || "";
      payload.wineOtherRatings = otherRatings;

      if (form.wineMyRating !== "") {
        payload.wineMyRating = Number(form.wineMyRating);
      }
    } else if (isFood) {
      payload.campaignItemsName = form.campaignItemsName || "";
      payload.campaignItemsText = form.campaignItemsText || "";
      payload.foodDate = form.foodDate || "";
      payload.foodLocation = form.foodLocation || "";

      if (form.foodRating !== "") {
        payload.foodRating = Number(form.foodRating);
      }
    } else {
      payload.campaignItemsName = form.campaignItemsName || "";
      payload.campaignItemsText = form.campaignItemsText || "";
    }

    // myOrganizerOriginalInput is intentionally never included here.

    setSaving(true);
    setError("");

    try {
      await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // For an existing Organizer item, save edits first. If the user
      // selected another Organizer list, move that same updated item
      // only after the update succeeds.
      const destinationCampaignName = form.moveToCampaignName || selectedCampaign;
      const shouldMove =
        isUpdate &&
        destinationCampaignName &&
        destinationCampaignName !== selectedCampaign;

      if (shouldMove) {
        if (!onMoveItem) {
          throw new Error("Move handler is not available.");
        }

        const moved = await onMoveItem(
          Number(form.campaignItemsId),
          destinationCampaignName
        );

        if (!moved) {
          throw new Error("The item was updated, but the move failed.");
        }
      }

      setShowEditModal(false);
      setForm(blankForm);

      // onMoveItem refreshes the source list after a move.
      // For a normal edit/add, refresh here.
      if (!shouldMove && onRefresh) {
        await onRefresh();
      }
    } catch (err) {
      console.error("UserList item save failed:", err);
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Failed to save item."
      );
    } finally {
      setSaving(false);
    }
  };

  const persistOrder = async (nextItems) => {
    if (isWine) return;
    if (!onReorder) return;

    try {
      const orderedItemIds = nextItems.map((item) =>
        Number(item.campaignItemsId)
      );

      await onReorder(orderedItemIds);
    } catch (err) {
      console.error("UserList reorder persistence failed:", err);
      setError("The item moved, but the new order could not be saved.");
    }
  };

  const applyReorder = (fromId, toId) => {
    if (isWine) return;

    if (fromId == null || toId == null || Number(fromId) === Number(toId)) {
      return;
    }

    setDisplayItems((prev) => {
      const fromIndex = prev.findIndex(
        (item) => Number(item.campaignItemsId) === Number(fromId)
      );

      const toIndex = prev.findIndex(
        (item) => Number(item.campaignItemsId) === Number(toId)
      );

      if (fromIndex < 0 || toIndex < 0) return prev;

      const next = moveArrayItem(prev, fromIndex, toIndex);
      persistOrder(next);
      return next;
    });
  };

  const moveItemBy = (itemId, offset) => {
    if (isWine) return;

    setDisplayItems((prev) => {
      const fromIndex = prev.findIndex(
        (item) => Number(item.campaignItemsId) === Number(itemId)
      );

      if (fromIndex < 0) return prev;

      const toIndex = Math.max(
        0,
        Math.min(prev.length - 1, fromIndex + offset)
      );

      if (fromIndex === toIndex) return prev;

      const next = moveArrayItem(prev, fromIndex, toIndex);
      persistOrder(next);
      return next;
    });
  };

  // Desktop drag/drop
  const handleDragStart = (e, itemId) => {
    setDraggingId(itemId);
    draggingRef.current = true;

    try {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", String(itemId));
    } catch (_) {}
  };

  const handleDragOver = (e, itemId) => {
    e.preventDefault();

    if (draggingId == null || Number(draggingId) === Number(itemId)) return;
    setDragOverId(itemId);
  };

  const handleDrop = (e, targetId) => {
    e.preventDefault();

    let sourceId = draggingId;

    if (sourceId == null) {
      try {
        sourceId = Number(e.dataTransfer.getData("text/plain"));
      } catch (_) {}
    }

    applyReorder(sourceId, targetId);

    setDraggingId(null);
    setDragOverId(null);
    draggingRef.current = false;
  };

  const handleDragEnd = () => {
    setDraggingId(null);
    setDragOverId(null);
    draggingRef.current = false;
  };

  // Phone/touch drag using Pointer Events.
  const handlePointerDown = (e, itemId) => {
    if (e.pointerType === "mouse") return;

    setDraggingId(itemId);
    setDragOverId(itemId);
    draggingRef.current = true;

    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (_) {}

    e.preventDefault();
  };

  const handlePointerMove = (e) => {
    if (!draggingRef.current || draggingId == null) return;

    const el = document.elementFromPoint(e.clientX, e.clientY);
    const card = el?.closest?.("[data-user-list-item-id]");

    if (!card) return;

    const targetId = Number(card.getAttribute("data-user-list-item-id"));

    if (!Number.isNaN(targetId)) {
      setDragOverId(targetId);
    }

    e.preventDefault();
  };

  const handlePointerUp = (e) => {
    if (!draggingRef.current) return;

    if (
      draggingId != null &&
      dragOverId != null &&
      Number(draggingId) !== Number(dragOverId)
    ) {
      applyReorder(draggingId, dragOverId);
    }

    try {
      e.currentTarget.releasePointerCapture(e.pointerId);
    } catch (_) {}

    draggingRef.current = false;
    setDraggingId(null);
    setDragOverId(null);

    e.preventDefault();
  };

  const renderOrganizerDetails = (item) => {
    const missing = item.myOrganizerMissingFields;

    return (
      <div
        style={{
          marginTop: "8px",
          fontSize: "0.82rem",
          lineHeight: 1.4,
          color: "#555",
        }}
      >
        {item.myOrganizerNeedsAttentionReason && (
          <div>
            <strong>Reason:</strong> {item.myOrganizerNeedsAttentionReason}
          </div>
        )}

        {item.myOrganizerSuggestedList && (
          <div>
            <strong>Suggested:</strong> {item.myOrganizerSuggestedList}
          </div>
        )}

        {Array.isArray(missing) && missing.length > 0 && (
          <div>
            <strong>Missing:</strong> {missing.join(", ")}
          </div>
        )}
      </div>
    );
  };

  const renderWineDetails = (item) => (
    <div
      style={{
        marginTop: "8px",
        fontSize: "0.82rem",
        lineHeight: 1.4,
        color: "#555",
      }}
    >
      {item.wineVintage && (
        <div>
          <strong>Vintage:</strong> {item.wineVintage}
        </div>
      )}

      {item.wineMyRating != null && item.wineMyRating !== "" && (
        <div>
          <strong>My rating:</strong> {item.wineMyRating}
        </div>
      )}

      {Array.isArray(item.wineOtherRatings) &&
        item.wineOtherRatings.map((entry, index) => (
          <div key={`${entry?.name || "rating"}-${index}`}>
            <strong>{entry?.name || "Other"}:</strong>{" "}
            {entry?.rating ?? ""}
          </div>
        ))}

      {item.wineLocation && (
        <div>
          <strong>Location:</strong> {item.wineLocation}
        </div>
      )}
    </div>
  );

  const renderFoodDetails = (item) => (
    <div
      style={{
        marginTop: "8px",
        fontSize: "0.82rem",
        lineHeight: 1.4,
        color: "#555",
      }}
    >
      {item.foodDate && (
        <div>
          <strong>Date:</strong> {item.foodDate}
        </div>
      )}

      {item.foodLocation && (
        <div>
          <strong>Location:</strong> {item.foodLocation}
        </div>
      )}

      {item.foodRating != null && item.foodRating !== "" && (
        <div>
          <strong>Rating:</strong> {item.foodRating}
        </div>
      )}
    </div>
  );

  const DragGrip = () => (
    <span
      aria-hidden="true"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 3px)",
        gridAutoRows: "3px",
        gap: "3px",
        justifyContent: "center",
        alignContent: "center",
        width: "16px",
        height: "26px",
      }}
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <span
          key={i}
          style={{
            width: "3px",
            height: "3px",
            borderRadius: "50%",
            background: "#999",
            display: "block",
          }}
        />
      ))}
    </span>
  );

  const renderWineAnchor = (rating, label) => {
    if (!label) return null;

    return (
      <div
        key={`wine-anchor-${rating}`}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          margin: "2px 0",
          color: "#666",
          fontSize: "0.78rem",
          fontWeight: 600,
        }}
      >
        <div style={{ flex: 1, borderTop: "1px solid #d8d8d8" }} />
        <div style={{ whiteSpace: "nowrap" }}>
          {rating} · {label}
        </div>
        <div style={{ flex: 1, borderTop: "1px solid #d8d8d8" }} />
      </div>
    );
  };

  const buildWineDisplayRows = () => {
    const anchors = [
      { rating: 75, label: listRecord?.wineAnchor75 || "" },
      { rating: 50, label: listRecord?.wineAnchor50 || "" },
      { rating: 25, label: listRecord?.wineAnchor25 || "" },
    ];

    const rows = [];
    let anchorIndex = 0;

    displayItems.forEach((item, index) => {
      const itemRating =
        item.wineMyRating != null && item.wineMyRating !== ""
          ? Number(item.wineMyRating)
          : -1;

      while (
        anchorIndex < anchors.length &&
        itemRating < anchors[anchorIndex].rating
      ) {
        const anchor = anchors[anchorIndex];
        rows.push(renderWineAnchor(anchor.rating, anchor.label));
        anchorIndex += 1;
      }

      rows.push(renderCard(item, index));
    });

    while (anchorIndex < anchors.length) {
      const anchor = anchors[anchorIndex];
      rows.push(renderWineAnchor(anchor.rating, anchor.label));
      anchorIndex += 1;
    }

    return rows;
  };

  const renderCard = (item, index) => {
    const itemId = Number(item.campaignItemsId);
    const isDragging = Number(draggingId) === itemId;
    const isDragOver =
      dragOverId != null &&
      Number(dragOverId) === itemId &&
      Number(draggingId) !== itemId;

    const title =
      item.campaignItemsName ||
      item.campaignItemsText ||
      `Item ${item.campaignItemsId}`;

    const secondaryText =
      item.campaignItemsName &&
      item.campaignItemsText &&
      item.campaignItemsName !== item.campaignItemsText
        ? item.campaignItemsText
        : "";

    return (
      <div
        key={item.campaignItemsId}
        data-user-list-item-id={item.campaignItemsId}
        draggable={!isWine}
        onDragStart={(e) => !isWine && handleDragStart(e, item.campaignItemsId)}
        onDragOver={(e) => !isWine && handleDragOver(e, item.campaignItemsId)}
        onDrop={(e) => !isWine && handleDrop(e, item.campaignItemsId)}
        onDragEnd={() => !isWine && handleDragEnd()}
        style={{
          border: isDragOver ? "1px solid #777" : "1px solid #e5e5e5",
          borderRadius: "10px",
          background: "#fff",
          opacity: isDragging ? 0.55 : 1,
          boxShadow: isDragging
            ? "0 3px 10px rgba(0,0,0,0.08)"
            : "0 1px 3px rgba(0,0,0,0.04)",
          transition:
            "border 120ms ease, box-shadow 120ms ease, opacity 120ms ease",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "28px minmax(0, 1fr) 54px",
            alignItems: "stretch",
          }}
        >
          {/* Drag handle / wine rating */}
          {isWine ? (
            <div
              title="My rating"
              style={{
                borderRight: "1px solid #eeeeee",
                background: "#fafafa",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "72px",
                fontWeight: 700,
                fontSize: "0.85rem",
                color: "#555",
              }}
            >
              {item.wineMyRating != null && item.wineMyRating !== ""
                ? item.wineMyRating
                : "—"}
            </div>
          ) : (
            <button
              type="button"
              aria-label={`Reorder ${title}`}
              title="Drag to reorder"
              onPointerDown={(e) => handlePointerDown(e, item.campaignItemsId)}
              onPointerMove={handlePointerMove}
              onPointerUp={handlePointerUp}
              onPointerCancel={handlePointerUp}
              style={{
                border: "0",
                borderRight: "1px solid #eeeeee",
                background: "#fafafa",
                cursor: "grab",
                touchAction: "none",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "72px",
              }}
            >
              <DragGrip />
            </button>
          )}

          {/* Main item content */}
          <div
            style={{
              padding: "10px 9px",
              minWidth: 0,
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                fontWeight: 650,
                fontSize: "0.98rem",
                lineHeight: 1.3,
                overflowWrap: "anywhere",
              }}
            >
              {title}
            </div>

            {secondaryText && (
              <div
                style={{
                  marginTop: "4px",
                  fontSize: "0.88rem",
                  lineHeight: 1.35,
                  color: "#555",
                  overflowWrap: "anywhere",
                }}
              >
                {secondaryText}
              </div>
            )}

            {isNeedsAttention && renderOrganizerDetails(item)}
            {isWine && renderWineDetails(item)}
            {isFood && renderFoodDetails(item)}

            <div
              style={{
                marginTop: "5px",
                fontSize: "0.62rem",
                color: "#b0b0b0",
              }}
              title="Item ID"
            >
              #{item.campaignItemsId}
            </div>
          </div>

          {/* Right-side actions */}
          <div
            style={{
              borderLeft: "1px solid #eeeeee",
              padding: "7px 7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
              fontSize: "0.68rem",
              background: "#fcfcfc",
            }}
          >
            <button
              className="action-link"
              type="button"
              onClick={() => openEdit(item)}
              style={{
                padding: "3px 9px",
                minWidth: "48px",
                border: "1px solid #d6d6d6",
                borderRadius: "999px",
                background: "#f7f7f7",
                textAlign: "center",
                textDecoration: "none",
                lineHeight: 1.15,
                cursor: "pointer",
              }}
            >
              Edit
            </button>

            {organizerMoveLists.length > 0 &&
              organizerMoveLists.some(
                (list) => list.campaignName === selectedCampaign
              ) && (
              <button
                className="action-link"
                type="button"
                onClick={() => {
                  openEdit(item);
                  window.setTimeout(() => {
                    document
                      .querySelector('select[name="moveToCampaignName"]')
                      ?.focus();
                  }, 0);
                }}
                style={{
                  padding: "3px 9px",
                  minWidth: "48px",
                  border: "1px solid #d6d6d6",
                  borderRadius: "999px",
                  background: "#f7f7f7",
                  textAlign: "center",
                  textDecoration: "none",
                  lineHeight: 1.15,
                  cursor: "pointer",
                }}
              >
                Move
              </button>
            )}

            <button
              className="action-link remove-link"
              type="button"
              onClick={() => onDelete && onDelete(item.campaignItemsId)}
              style={{
                padding: "3px 9px",
                minWidth: "48px",
                border: "1px solid #e2caca",
                borderRadius: "999px",
                background: "#fff8f8",
                textAlign: "center",
                textDecoration: "none",
                lineHeight: 1.15,
                cursor: "pointer",
              }}
            >
              Delete
            </button>

            {item.campaignItemsURL1 && (
              <a
                className="action-link more-info-link"
                href={item.campaignItemsURL1}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  padding: "3px 9px",
                  minWidth: "48px",
                  boxSizing: "border-box",
                  border: "1px solid #d6d6d6",
                  borderRadius: "999px",
                  background: "#f7f7f7",
                  textAlign: "center",
                  textDecoration: "none",
                  lineHeight: 1.15,
                }}
              >
                Open
              </a>
            )}

            {!isWine && (
              <div
                style={{
                  borderTop: "1px solid #eeeeee",
                  marginTop: "2px",
                  paddingTop: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "3px",
                }}
              >
                <button
                  type="button"
                  className="action-link"
                  disabled={index === 0}
                  onClick={() => moveItemBy(item.campaignItemsId, -1)}
                  title="Move up"
                  style={{
                    width: "25px",
                    height: "20px",
                    padding: 0,
                    border: "1px solid #d8d8d8",
                    borderRadius: "7px",
                    background: "#f7f7f7",
                    opacity: index === 0 ? 0.22 : 0.72,
                    textDecoration: "none",
                    fontSize: "1rem",
                    fontWeight: 800,
                    lineHeight: 1,
                    cursor: index === 0 ? "default" : "pointer",
                  }}
                >
                  ↑
                </button>

                <button
                  type="button"
                  className="action-link"
                  disabled={index === displayItems.length - 1}
                  onClick={() => moveItemBy(item.campaignItemsId, 1)}
                  title="Move down"
                  style={{
                    width: "25px",
                    height: "20px",
                    padding: 0,
                    border: "1px solid #d8d8d8",
                    borderRadius: "7px",
                    background: "#f7f7f7",
                    opacity:
                      index === displayItems.length - 1 ? 0.22 : 0.72,
                    textDecoration: "none",
                    fontSize: "1rem",
                    fontWeight: 800,
                    lineHeight: 1,
                    cursor:
                      index === displayItems.length - 1
                        ? "default"
                        : "pointer",
                  }}
                >
                  ↓
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "14px",
          marginBottom: "14px",
          paddingBottom: "10px",
          borderBottom: "1px solid #ececec",
          width: "calc(100vw - 8px)",
          maxWidth: "430px",
          marginLeft: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: "1.05rem",
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            {isNeedsAttention
              ? "Needs Attention"
              : isWine
              ? "Wine"
              : isFood
              ? "Food"
              : "Items"}
          </div>

          <div
            style={{
              marginTop: "3px",
              fontSize: "0.75rem",
              color: "#888",
            }}
          >
            {displayItems.length} item{displayItems.length === 1 ? "" : "s"}
            {isWine
              ? " · sorted by my rating"
              : displayItems.length > 1
              ? " · drag to reorder"
              : ""}
          </div>
        </div>

        <button
          className="save-button"
          type="button"
          onClick={openAdd}
          style={{
            width: "auto",
            minWidth: "58px",
            padding: "6px 9px",
          }}
        >
          Add
        </button>
      </div>

      {error && (
        <div className="error-message" style={{ marginBottom: "10px" }}>
          {error}
        </div>
      )}

      {displayItems.length === 0 ? (
        <div
          style={{
            border: "1px dashed #ddd",
            borderRadius: "10px",
            padding: "24px",
            textAlign: "center",
            color: "#777",
            background: "#fafafa",
          }}
        >
          No items yet.
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr)",
            gap: "8px",
            width: "calc(100vw - 8px)",
            maxWidth: "430px",
            marginLeft: "50%",
            transform: "translateX(-50%)",
          }}
        >
          {isWine
            ? buildWineDisplayRows()
            : displayItems.map((item, index) => renderCard(item, index))}
        </div>
      )}

      {showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="edit-options-container">
              <h3 className="page-header">
                {form.campaignItemsId ? "Update Item" : "Add Item"}
              </h3>

              {isWine ? (
                <>
                  <label>
                    Wine:
                    <input
                      name="wineName"
                      value={form.wineName || ""}
                      onChange={handleChange}
                      placeholder="Wine name"
                    />
                  </label>

                  <label>
                    Producer / Winery:
                    <input
                      name="wineProducer"
                      value={form.wineProducer || ""}
                      onChange={handleChange}
                      placeholder="Optional producer or winery"
                    />
                  </label>

                  <label>
                    Vintage:
                    <input
                      name="wineVintage"
                      value={form.wineVintage || ""}
                      onChange={handleChange}
                      placeholder="Year"
                    />
                  </label>

                  <label>
                    My Rating:
                    <input
                      type="number"
                      min="0"
                      max="100"
                      name="wineMyRating"
                      value={form.wineMyRating || ""}
                      onChange={handleChange}
                      placeholder="0-100"
                    />
                  </label>

                  <label>
                    Location:
                    <input
                      name="wineLocation"
                      value={form.wineLocation || ""}
                      onChange={handleChange}
                      placeholder="Where you had it"
                    />
                  </label>

                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ fontWeight: 600, marginBottom: "6px" }}>
                      Other Ratings:
                    </div>

                    {(form.wineOtherRatings || []).map((entry, index) => (
                      <div
                        key={index}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 84px auto",
                          gap: "6px",
                          alignItems: "center",
                          marginBottom: "6px",
                        }}
                      >
                        <input
                          value={entry?.name || ""}
                          onChange={(e) =>
                            handleWineOtherRatingChange(
                              index,
                              "name",
                              e.target.value
                            )
                          }
                          placeholder="Name"
                        />

                        <input
                          type="number"
                          min="0"
                          max="100"
                          value={entry?.rating || ""}
                          onChange={(e) =>
                            handleWineOtherRatingChange(
                              index,
                              "rating",
                              e.target.value
                            )
                          }
                          placeholder="0-100"
                        />

                        <button
                          type="button"
                          className="action-link remove-link"
                          onClick={() => removeWineOtherRating(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}

                    <button
                      type="button"
                      className="action-link"
                      onClick={addWineOtherRating}
                    >
                      Add Rating
                    </button>
                  </div>

                  <label>
                    Notes:
                    <textarea
                      name="wineNotes"
                      value={form.wineNotes || ""}
                      onChange={handleChange}
                      rows={4}
                      placeholder="Notes"
                    />
                  </label>
                </>
              ) : isFood ? (
                <>
                  <label>
                    Restaurant / Place:
                    <input
                      name="campaignItemsName"
                      value={form.campaignItemsName || ""}
                      onChange={handleChange}
                      placeholder="Restaurant or place"
                    />
                  </label>

                  <label>
                    Date:
                    <input
                      name="foodDate"
                      value={form.foodDate || ""}
                      onChange={handleChange}
                      placeholder="Optional date"
                    />
                  </label>

                  <label>
                    Location:
                    <input
                      name="foodLocation"
                      value={form.foodLocation || ""}
                      onChange={handleChange}
                      placeholder="City or location"
                    />
                  </label>

                  <label>
                    Rating:
                    <input
                      type="number"
                      min="0"
                      max="100"
                      name="foodRating"
                      value={form.foodRating || ""}
                      onChange={handleChange}
                      placeholder="Optional 0-100"
                    />
                  </label>

                  <label>
                    Notes:
                    <textarea
                      name="campaignItemsText"
                      value={form.campaignItemsText || ""}
                      onChange={handleChange}
                      rows={5}
                      placeholder="Food, dishes, comments"
                    />
                  </label>
                </>
              ) : (
                <>
                  <label>
                    Name:
                    <input
                      name="campaignItemsName"
                      value={form.campaignItemsName || ""}
                      onChange={handleChange}
                      placeholder="Name"
                    />
                  </label>

                  {isNeedsAttention && (
                    <>
                      {form.myOrganizerNeedsAttentionReason && (
                        <div style={{ marginBottom: "8px", fontSize: "0.82rem", color: "#555" }}>
                          <strong>Reason:</strong>{" "}
                          {form.myOrganizerNeedsAttentionReason}
                        </div>
                      )}

                      {form.myOrganizerSuggestedList && (
                        <div style={{ marginBottom: "8px", fontSize: "0.82rem", color: "#555" }}>
                          <strong>Suggested:</strong>{" "}
                          {form.myOrganizerSuggestedList}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              <div
                style={{
                  marginTop: "18px",
                  paddingTop: "14px",
                  borderTop: "2px solid #d8d8d8",
                }}
              >
                <label
                  style={{
                    fontSize: "0.82rem",
                    color: "#555",
                  }}
                >
                  Main Text:
                  <input
                    name="campaignItemsText"
                    value={form.campaignItemsText || ""}
                    onChange={handleChange}
                    placeholder="Item text"
                    style={{
                      fontSize: "0.82rem",
                      fontFamily: "inherit",
                    }}
                  />
                </label>
              </div>

              {form.campaignItemsId &&
                organizerMoveLists.length > 0 &&
                organizerMoveLists.some(
                  (list) => list.campaignName === selectedCampaign
                ) && (
                <div
                  style={{
                    marginTop: "8px",
                  }}
                >
                  <label
                    style={{
                      fontSize: "0.82rem",
                      color: "#555",
                    }}
                  >
                    Move to List:
                    <select
                      name="moveToCampaignName"
                      value={form.moveToCampaignName || selectedCampaign || ""}
                      onChange={handleChange}
                      style={{
                        fontSize: "0.82rem",
                        fontFamily: "inherit",
                      }}
                    >
                    <option value={selectedCampaign}>
                      Keep in{" "}
                      {organizerMoveLists.find(
                        (list) => list.campaignName === selectedCampaign
                      )?.displayName || "current list"}
                    </option>

                    {organizerMoveLists
                      .filter(
                        (list) => list.campaignName !== selectedCampaign
                      )
                      .map((list) => (
                        <option
                          key={list.campaignName}
                          value={list.campaignName}
                        >
                          {list.displayName}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              )}

              {form.campaignItemsId && form.myOrganizerOriginalInput && (
                <label
                  style={{
                    fontSize: "0.82rem",
                    color: "#666",
                  }}
                >
                  Original Capture:
                  <input
                    value={form.myOrganizerOriginalInput}
                    readOnly
                    style={{
                      background: "#f7f7f7",
                      color: "#666",
                      fontSize: "0.82rem",
                    }}
                  />
                </label>
              )}

              {form.campaignItemsId &&
                (form.myOrganizerOriginalInput || form.myOrganizerDecision) && (
                <label
                  style={{
                    fontSize: "0.82rem",
                    color: "#666",
                  }}
                >
                  AI Decision:
                  <textarea
                    value={
                      form.myOrganizerDecision ||
                      "AI decision trail was not saved on this older item."
                    }
                    readOnly
                    rows={4}
                    style={{
                      background: "#f7f7f7",
                      color: "#666",
                      width: "100%",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      resize: "vertical",
                      fontSize: "0.82rem",
                      fontFamily: "inherit",
                    }}
                  />
                </label>
              )}

              <div className="button-group">
                <button
                  className="save-button"
                  type="button"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving
                    ? "Saving..."
                    : form.campaignItemsId
                    ? "Update"
                    : "Add"}
                </button>

                <button
                  className="save-button"
                  type="button"
                  onClick={closeEdit}
                  disabled={saving}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserListItems;
